import { z } from "zod";

export const uuidSchema = z.string().uuid();

/**
 * Confidence in [0, 1].
 * Backed by PostgreSQL double precision (JS number), not numeric/decimal.
 */
export const confidenceSchema = z.number().min(0).max(1);

/**
 * Estimated operational API cost in USD (Phase 1).
 * Backed by PostgreSQL double precision — estimates, not financial ledger balances.
 */
export const costUsdSchema = z.number().nonnegative();

export const isoDateTimeSchema = z.string().datetime({ offset: true });

export const nonEmptyStringSchema = z.string().trim().min(1);
